import React from 'react';
import { styled } from 'styled-components';

interface Props {
  children: React.ReactNode;
}

export default function DashboardPageModalWrap({ children }: Props) {
  return <Wrap>{children}</Wrap>;
}

const Wrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  @media (max-width: 768px) {
    margin: 50px auto;
    padding: 0 4px;
  }

  @media (max-width: 480px) {
    margin: 0 auto;
  }
`;
